export default __webpack_public_path__ + "static/media/drop-down.c0e1735f.svg";